module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "new-talent"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("达人管理 >\n        "), _c('span', [_vm._v("新增达人账号")]), _vm._v(" "), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTalent
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "talent-box"
  }, [_c('el-form', {
    ref: "talentForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.talentForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "prop": "phoneNumber"
    }
  }, [_c('el-input', {
    staticClass: "talentTitle",
    attrs: {
      "placeholder": "请输入手机号"
    },
    on: {
      "blur": _vm.sendPhoneToCheck
    },
    model: {
      value: (_vm.talentForm.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.talentForm, "phoneNumber", $$v)
      },
      expression: "talentForm.phoneNumber"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.errorMsg))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名：",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "talentTitle",
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.talentForm.name),
      callback: function($$v) {
        _vm.$set(_vm.talentForm, "name", $$v)
      },
      expression: "talentForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校区：",
      "prop": "zoneName"
    }
  }, [_c('el-input', {
    staticClass: "talentTitle",
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.talentForm.zoneName),
      callback: function($$v) {
        _vm.$set(_vm.talentForm, "zoneName", $$v)
      },
      expression: "talentForm.zoneName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "院系：",
      "prop": "departName"
    }
  }, [_c('el-input', {
    staticClass: "talentTitle",
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.talentForm.departName),
      callback: function($$v) {
        _vm.$set(_vm.talentForm, "departName", $$v)
      },
      expression: "talentForm.departName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发视频功能：",
      "prop": "videoEnable"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.talentForm.videoEnable),
      callback: function($$v) {
        _vm.$set(_vm.talentForm, "videoEnable", $$v)
      },
      expression: "talentForm.videoEnable"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6922b5b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/talent/newTalent.vue
// module id = 1059
// module chunks = 0